export default __webpack_public_path__ + "static/media/social.8f2634d3.png";